import { useTranslate } from "ra-core";
import type { ReactNode } from "react";

import { MobileContent } from "../layout/MobileContent";
import MobileHeader from "../layout/MobileHeader";
import { MobileBackButton } from "../misc/MobileBackButton";

/** Настройки → Проекты / Сотрудники on a phone: header with a way back. */
export const MobileSettingsSubpage = ({
  title,
  children,
}: {
  title: string;
  children: ReactNode;
}) => {
  const translate = useTranslate();
  return (
    <>
      <MobileHeader>
        <div className="flex items-center gap-2 min-w-0">
          <MobileBackButton to="/settings" />
          <h1 className="text-xl font-semibold truncate">{translate(title)}</h1>
        </div>
      </MobileHeader>
      <MobileContent>{children}</MobileContent>
    </>
  );
};
